import { styled } from '@mui/material/styles';
import Link from "components/Link";

export const DownloadLink = styled(Link)(({ theme }) => ({
  fontSize: theme.fontSize.xsmall
}));

export const DownloadText = styled('span')(({ theme }) => ({
  fontWeight: theme.fontWeight.bold,
  marginLeft: theme.spacing(1),
  textTransform: 'uppercase'
}));

export const ActionItem = styled('div')(() => ({
  alignItems: 'center',
  display: 'flex',
  float: 'right',
  '@media (max-width: 660px)': {
    float: 'left'
  },
  '& svg': {
    fontSize: '2em'
  }
}));

export const TermsHeaderText = styled('div')(() => ({
  width: '100%',
  alignItems: 'left',
  display: 'flex',
  flexWrap: 'wrap',
  flexFlow: 'column',
  fontSize: 'larger'
}));